export const storiesFolderKeys = {
  all: ["stories-folders"] as const,
  storiesFolders: ["stories-folders", "list"] as const,
  storiesFoldersCount: ["stories-folders", "count"] as const,
};